<c-flexible-view configuration="flexViewConfig">
</c-flexible-view>
